import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { PrimaryButton } from '@components/Button/variants';
import useEventTracking from '@hooks/useEventTracking';
import { subscribe_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { TrackingLocation } from '@tracking';
import { OfferOption } from '@utils/backend-api/subscribe';
import { extractQueryParams } from '@utils/queryStringHelper';

interface HorizentalOfferProps {
  offer: OfferOption;
}

const DUAL_SOURCE = 'dual';

const HorizontalOffer = ({ offer }: HorizentalOfferProps) => {
  const {
    billingFrequencyOverride,
    code,
    currentPrice,
    currentPriceDisplayOverride,
    description,
    isYp,
    originalPrice,
    originalPriceDisplayOverride,
    title,
  } = offer;
  const currentPriceToDisplay = currentPriceDisplayOverride || currentPrice;
  const hasDiscount = originalPrice !== currentPrice;
  const { article_id, modal } = extractQueryParams(['article_id', 'modal']);

  const originalPriceToDisplay = originalPriceDisplayOverride || originalPrice;
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.HorizontalOffer,
  });

  return (
    <>
      <div className="flex w-[445px] flex-col gap-8 md:w-[480px]">
        {isYp && <div className="text-overline-md text-grayscale-gray">30 or under only</div>}

        <div className="flex flex-wrap items-center justify-between gap-8">
          <div className="w-full font-suisse-works text-headline-xxs md:w-auto">{title}</div>
          <div className="flex flex-wrap items-center">
            <span className="font-suisse-screen text-headline-alt-sm font-bold text-black">
              ${currentPriceToDisplay}
            </span>{' '}
            {hasDiscount && (
              <span className="ml-8 font-suisse-screen text-headline-alt-sm text-grayscale-gray line-through sm:ml-8">
                ${originalPriceToDisplay}
              </span>
            )}
            {billingFrequencyOverride && (
              <span className="ml-8 font-suisse-screen text-disclosure-lg text-grayscale-charcoal sm:ml-8">
                {billingFrequencyOverride}
              </span>
            )}
          </div>
        </div>
        <div className="font-suisse-intl text-body-md text-grayscale-charcoal sm:text-body-lg">
          {ReactHtmlParser(description)}
        </div>
      </div>
      <PrimaryButton
        as="link"
        size="small"
        className="w-auto flex-shrink-0 px-48 py-8 md:mt-0"
        href={subscribe_path({
          offer: code,
          source: DUAL_SOURCE,
          ...(article_id && { article_id }),
          ...(modal && { modal }),
        })}
        onClickCapture={() =>
          trackEvent(click({ clickTarget: ClickTarget.Offer, offerCode: code }))
        }
      >
        Subscribe
      </PrimaryButton>
    </>
  );
};

export default HorizontalOffer;
